/* eslint-disable */
export function setLocalStorage (name, value) {
  typeof value === 'object'
    ? localStorage.setItem(name, JSON.stringify(value))
    : localStorage.setItem(name, value)
}
